export enum DashboardEventNames {
  DASHBOARD_DATE_FILTER_CLICK = 'analyticspage.click_date_filter',
  DASHBOARD_WORKSPACE_FILTER_CLICK = 'analyticspage.click_workspapce_filter',
  DASHBOARD_INTERNAL_SESSIONS_CLICK = 'analyticspage.click_internal_sessions',
  DASHBOARD_SHORT_SESSIONS_CLICK = 'analyticspage.click_short_sessions',
  DASHBOARD_TABS_CLICK = 'analyticspage.click_tabs',
  DASHBOARD_VIEW_MORE_CLICK = 'analyticspage.click_view_more',
  DASHBOARD_DOWNLOAD_CSV_CLICK = 'analyticspage.download_activity_table',
  DASHBOARD_SESSIONS_BREAKDOWN_TABS_CLICK = 'analyticspage.click_table_tabs',
  DASHBOARD_SESSIONS_BREAKDOWN_PRESENTER_FILTER_CLICK = 'analyticspage.click_table_presenter_filter',
  DASHBOARD_SESSIONS_BREAKDOWN_OPPORTUNITY_FILTER_CLICK = 'analyticspage.click_table_opportunity_filter',
}

export enum IntegrationEventNames {
  CONNECT_INTEGRATION_CLICK = 'integration.click_connect',
  DELETE_INTEGRATION_CLICK = 'integration.click_delete',
  PAUSE_INTEGRATION_CLICK = 'integration.click_pause',
  RESUME_INTEGRATION_CLICK = 'integration.click_resume',
  RECONNECT_INTEGRATION_CLICK = 'integration.click_reconnect',
}

export enum FolderEventNames {
  FOLDER_CLICK_CREATE = 'folder.click_create',
  FOLDER_CLICK_CREATE_COPY_MODAL = 'folder.click_create_copy_modal',
  FOLDER_CLICK_ASSET_MOVE_MODAL = 'folder.click_asset_move_modal',
  FOLDER_CLICK_CONFIRM_ARCHIVE = 'folder.click_confirm_archive',
  FOLDER_CLICK_CONFIRM_ARCHIVE_DEACTIVATE_LINKS = 'folder.click_confirm_archive_deactivate_links',
  FOLDER_CLICK_RESTORE = 'folder.click_restore',
}

export enum PlayEventNames {
  PLAY_CLICK_PLAY_NOW = 'play.click_play_now',
  PLAY_CLICK_PLAY_LATER = 'play.click_play_later',
  PLAY_OPEN_CUSTOMIZE_MODAL = 'play.open_customize_modal',
  PLAY_OPEN_ASSET_NOTES = 'play.open_asset_notes',
  PLAY_OPEN_ASSET_VARIABLES = 'play.open_asset_variables',
  PLAY_SAVE_CUSTOMIZATIONS = 'play.save_customizations',
  PLAY_DISCARD_CUSTOMIZATIONS = 'play.discard_customizations',
}
export enum NetworkEventNames {
  CONNECTION_NETWORK_DISCONNECTED = 'connection.network_disconnected',
  CONNECTION_NETWORK_DEGRADED = 'connection.network_degraded',
  CONNECTION_NETWORK_ONLINE = 'connection.network_online',
}
export enum PlaybookEventNames {
  PLAYBOOK_CLICK_CREATE = 'playbook.click_create',
  PLAYBOOK_CLICK_PRESENT = 'playbook.click_present',
  PLAYBOOK_CLICK_PREVIEW = 'playbook.click_preview',
  PLAYBOOK_CLICK_UPDATE = 'playbook.click_update',
  PLAYBOOK_CLICK_ARCHIVE = 'playbook.click_archive',
  PLAYBOOK_CLICK_ARCHIVE_PRESENTATION = 'playbook.click_archive_presentation',
  PLAYBOOK_CLICK_DUPLICATE = 'playbook.click_duplicate',
  SUBMIT_CREATE_PLAYBOOK = 'playbook.click_create_playbook_modal',
  SUBMIT_UPDATE_PLAYBOOK = 'playbook.click_update_playbook_modal',
  CREATE_PLAYBOOK_EXTERNAL_URL = 'playbook.add_url_playbook_modal',
  EDIT_PLAYBOOK_EXTERNAL_URL = 'playbook.edit_url_playbook_modal',
  REMOVE_PLAYBOOK_EXTERNAL_URL = 'playbook.remove_url_playbook_modal',
  REORDER_PLAYBOOK_ASSETS = 'playbook.click_reorder_playbook_modal',
  CHANGE_NAME_INPUT = 'playbook.change_name_input_playbook_modal',
  DISCARD_PLAYBOOK_CHANGES = 'playbook.discard_changes_playbook_modal',
  PLAYBOOK_CLICK_SHARE_INTERNALLY = 'playbook.click_share_internally',
}

export enum WorkspaceRelatedTrackEventNames {
  WORKSPACE_CLICK_OPEN_CREATE_MODAL = 'workspace.click_open_create_modal',
  WORKSPACE_CLICK_CREATE = 'workspace.click_create',
  WORKSPACE_CLICK_OPEN_MEMBERS_MODAL = 'workspace.click_open_members_modal',
  WORKSPACE_INSERT_MEMBER_EMAIL = 'workspace.insert_member_email',
  WORKSPACE_INSERT_MEMBER_NOT_IN_ORG = 'workspace.insert_member_not_in_org',
  WORKSPACE_INSERT_MEMBER_INVALID_EMAIL = 'workspace.insert_member_invalid_email',
  WORKSPACE_CLICK_CLOSE_MEMBERS_MODAL = 'workspace.click_close_members_modal',
  WORKSPACE_CLICK_ADD_MEMBER = 'workspace.click_add_member',
  WORKSPACE_CLICK_JOIN = 'workspace.click_join',
  WORKSPACE_CLICK_REMOVE_MEMBER = 'workspaces.click_remove_member',
  WORKSPACE_CLICK_LEAVE = 'workspace.click_leave',
  WORKSPACE_CLICK_ARCHIVE_DEACTIVATE_SHARED_LINKS = 'workspace.click_archive_deactivate_shared_links',
  WORKSPACE_CLICK_APPROVE_ARCHIVE = 'workspace.click_approve_archive',
  WORKSPACE_CLICK_CANCEL_ARCHIVE = 'workspace.click_cancel_archive',
  WORKSPACE_CLICK_OPEN_ARCHIVE_MODAL = 'workspace.click_open_archive_modal',
  WORKSPACE_CLICK_OPEN_EDIT_SETTINGS_MODAL = 'workspace.click_open_edit_settings_modal',
  WORKSPACE_CLICK_ALL_WORKSPACES = 'workspace.click_all_workspaces',
  WORKSPACE_CLICK_DRAFTS = 'workspace.click_drafts',
  WORKSPACE_CLICK_ALL_ARCHIVED_WORKSPACES = 'workspace.click_all_archived_workspaces',
  WORKSPACE_CLICK_RESTORE = 'workspace.click_restore',
  WORKSPACE_SELECT_WORKSPACE = 'workspace.select_workspace',
  DEMO_CLICK_OPEN_COPY_TO_WORKSPACE_MODAL = 'demo.click_open_copy_to_workspace_modal',
  DEMO_CLICK_CREATE_NEW_COPY = 'demo.click_create_new_copy',
  DEMO_CLICK_CANCEL_COPY = 'demo.click_cancel_copy',
  CLONE_CLICK_OPEN_COPY_TO_WORKSPACE_MODAL = 'clone.click_open_copy_to_workspace_modal',
  CLONE_CLICK_CANCEL_COPY = 'clone.click_cancel_copy',
  CLONE_CLICK_CREATE_NEW_COPY = 'clone.click_create_new_copy',
  TOUR_CLICK_OPEN_COPY_TO_WORKSPACE_MODAL = 'tour.click_open_copy_to_workspace_modal',
  TOUR_CLICK_OPEN_MOVE_TO_WORKSPACE_MODAL = 'tour.click_open_move_to_workspace_modal',
  WORKSPACE_NO_ACCESS = 'workspace.no_access',
}

export enum TrackEventMimesis {
  MIMESIS_REPLICATE_ERROR = 'mimesis-replicate.error',
  MIMESIS_ENGINE_ERROR = 'mimesis-engine.error',
  MIMESIS_SDK_ERROR = 'mimesis-sdk.error',
}

export enum TrackEventTourNames {
  TOUR_CLICK_CREATE = 'tour.click_create',
  TOUR_CLICK_DEMO = 'tour.click_demo',
  TOUR_CLICK_CREATE_DEMO = 'tour.click_create_demo',
  TOUR_CLICK_START_CAPTURE = 'tour.click_start_capture',
  TOUR_CLICK_FINISH_CAPTURE = 'tour.click_finish_capture',
  TOUR_CLICK_RESTART_CAPTURE = 'tour.click_restart_capture',
  TOUR_CLICK_SAVE = 'tour.click_save',
  TOUR_CLICK_PUBLISH = 'tour.click_publish',
  TOUR_CLICK_SHARE = 'tour.click_share',
  TOUR_CREATE_SHARE_LINK = 'tour.create_share_link',
  TOUR_UPDATE_SHARE_ASPECT_RATIO = 'tour.update_share_link_aspect_ratio',
  TOUR_UPDATE_SHARE_LINK = 'tour.update_share_link',
  TOUR_CLICK_TOGGLE_SHARE = 'tour.click_toggle_share',
  TOUR_CLICK_OPEN_CREATE_MODAL = 'tour.click_open_create_modal',
  TOUR_CLICK_DUPLICATE = 'tour.click_duplicate',
  TOUR_CLICK_OPEN_CREATE_SHARE_LINK_MODAL = 'tour.click_open_create_share_link_modal',
  TOUR_TOGGLE_SHARE = 'tour.toggle_share',
  TOUR_CLICK_OPEN_DUPLICATE_MODAL = 'tour.click_open_duplicate_modal',
  TOUR_CLICK_EDITOR_DISCARD_AND_EXIT = 'tour.click_editor_discard_and_exit',
  TOUR_CLICK_PREVIEW = 'tour.click_preview',
  TOUR_RENAME_FRAME = 'tour.rename_frame',
  TOUR_CLICK_DELETE_FRAME = 'tour.click_delete_frame',
  TOUR_CLICK_RESTORE_FRAME = 'tour.click_restore_frame',
  TOUR_TOGGLE_FRAME_VISIBILITY = 'tour.toggle_frame_visibility',
  TOUR_CLICK_ADD_STEP_TO_FRAME = 'tour.click_add_step_to_frame',
  TOUR_CLICK_CANCEL_INSPECT_MODE = 'tour.click_cancel_inspect_mode',
  TOUR_CLICK_DELETE_STEP = 'tour.click_delete_step',
  TOUR_DRAG_REORDER_STEP = 'tour.drag_reorder_step',
  TOUR_CLICK_RESTORE_STEP = 'tour.click_restore_step',
  TOUR_CLICK_UPLOAD_SCREENSHOT = 'tour.click_upload_screenshot',
  TOUR_CLICK_CONVERT_FRAME = 'tour.click_convert_frame',
  TOUR_CLICK_CONVERT_FRAME_TOOLTIP_OUTSIDE_SCREENSHOT_AREA = 'tour.click_convert_frame_tooltip_outside_screenshot_area',
  TOUR_TOGGLE_BUTTONS_NAVIGATION_ON = 'tour.toggle_buttons_navigation_on',
  TOUR_TOGGLE_BUTTONS_NAVIGATION_OFF = 'tour.toggle_buttons_navigation_off',
  TOUR_TOGGLE_ELEMENT_NAVIGATION_ON = 'tour.toggle_element_navigation_on',
  TOUR_TOGGLE_ELEMENT_NAVIGATION_OFF = 'tour.toggle_element_navigation_off',
  TOUR_TOGGLE_ARROW_ON = 'tour.toggle_arrow_on',
  TOUR_TOGGLE_ARROW_OFF = 'tour.toggle_arrow_off',
  TOUR_TOGGLE_HIGHLIGHT_ON = 'tour.toggle_highlight_on',
  TOUR_TOGGLE_HIGHLIGHT_OFF = 'tour.toggle_highlight_off',
  TOUR_CHANGE_HIGHLIGHT_STYLE = 'tour.change_highlight_style',
  TOUR_TOGGLE_SPOTLIGHT_ON = 'tour.toggle_spotlight_on',
  TOUR_TOGGLE_SPOTLIGHT_OFF = 'tour.toggle_spotlight_off',
  TOUR_CHANGE_SPOTLIGHT_STYLE = 'tour.change_spotlight_style',
  TOUR_CHANGE_TOOLTIP_COLOR_AND_SHAPE_STYLE = 'tour.change_tooltip_color_and_shape_style',
  TOUR_CHANGE_TOOLTIP_SHADOW_STYLE = 'tour.change_tooltip_shadow_style',
  TOUR_TOGGLE_TOOLTIP_USE_DROP_SHADOW = 'tour.toggle_tooltip_use_drop_shadow',
  TOUR_CLICK_TOOLTIP_ELEMENT_NAVIGATION_NAVIGATE_TO = 'tour.click_tooltip_element_navigation_navigate_to',
  TOUR_CLICK_TOOLTIP_LAYOUT = 'tour.click_tooltip_layout',
  TOUR_TOGGLE_TOOLTIP_DISPLAY_TOOLTIP_ARROW = 'tour.click_tooltip_display_tooltip_arrow',
  TOUR_CLICK_TOOLTIP_RESELECT_TARGET_ELEMENT = 'tour.click_tooltip_reselect_target_element',
  TOUR_CLICK_TOOLTIP_APPLY_TO_ALL = 'tour.click_tooltip_apply_to_all',
  TOUR_CLICK_TOOLTIP_ADD_MEDIA = 'tour.click_tooltip_add_media',
  TOUR_CLICK_TOOLTIP_DELETE_MEDIA = 'tour.click_tooltip_delete_media',
  TOUR_CLICK_TOOLTIP_REPLACE_MEDIA = 'tour.click_tooltip_replace_media',
  TOUR_CLICK_TOOLTIP_ADD_AUDIO = 'tour.click_tooltip_add_audio',
  TOUR_CLICK_TOOLTIP_DELETE_AUDIO = 'tour.click_tooltip_delete_audio',
  TOUR_CLICK_TOOLTIP_REPLACE_AUDIO = 'tour.click_tooltip_replace_audio',
  TOUR_TOGGLE_STEPS_COUNTER = 'tour.toggle_steps_counter',
  TOUR_TOGGLE_RESPONSIVE = 'tour.toggle_responsive',
  TOUR_TOGGLE_WRAPPER_TYPE = 'tour.toggle_wrapper_type',
  TOUR_TOGGLE_SHOW_TOOLTIPS = 'tour.toggle_show_tooltips',
  TOUR_TOGGLE_NAVIGATION_MENU = 'tour.toggle_navigation_menu',
  TOUR_TOGGLE_SHOW_SPECIFIC_TOOLTIP = 'tour.toggle_show_specific_tooltip',
  TOUR_CHANGE_STYLE_STEPS_COUNTER = 'tour.change_style_steps_counter',
  TOUR_CLICK_OPEN_ADD_FRAME_MODAL = 'click_open_add_frame_modal',
  TOUR_CLICK_CAPTURE_NEW_FRAMES = 'tour.click_capture_new_frames',
  TOUR_CLICK_ADD_FRAME_FINISH = 'tour.click_add_frame_finish',
  TOUR_CLICK_OPEN_CANCEL_MODAL = 'tour.click_open_cancel_modal',
  TOUR_CLICK_APPROVE = 'tour.click_approve',
  TOUR_CLICK_CANCEL = 'tour.click_cancel',
  TOUR_SELECT_ASSET = 'tour.select_asset',
  TOUR_CLICK_EDIT = 'tour.click_edit',
  TOUR_CLICK_COPY_TO_WORKSPACE = 'tour.click_copy_to_workspace',
  TOUR_CLICK_MOVE_TO_WORKSPACE = 'tour.click_move_to_workspace',
  TOUR_CLICK_ARCHIVE = 'tour.click_archive',
  TOUR_CLICK_COPY_EMBEDDED_CODE = 'tour.click_copy_embedded_code',
  TOUR_CLICK_COPY_LINK_URL = 'tour.click_copy_link_url',
  TOUR_CLICK_SHARE_SETTINGS = 'tour.click_share_settings',
  TOUR_CLICK_ACTIVATE_SHARE = 'tour.click_activate_share',
  TOUR_CLICK_DEACTIVATE_SHARE = 'tour.click_deactivate_share',
  TOUR_CLICK_REVERT = 'tour.click_revert',
  TOUR_CLICK_REVERT_APPROVE = 'tour.click_revert_approve',
  TOUR_CLICK_REVERT_CANCEL = 'tour.click_revert_cancel',
  TOUR_CLICK_DUPLICATE_APPROVE = 'tour.click_duplicate_approve',
  TOUR_CLICK_DUPLICATE_CANCEL = 'tour.click_duplicate_cancel',
  TOUR_CLICK_COPY_TO_WORKSPACE_APPROVE = 'tour.click_copy_to_workspace_approve',
  TOUR_CLICK_COPY_TO_WORKSPACE_CANCEL = 'tour.click_copy_to_workspace_cancel',
  TOUR_CLICK_MOVE_TO_WORKSPACE_APPROVE = 'tour.click_move_to_workspace_approve',
  TOUR_CLICK_MOVE_TO_WORKSPACE_CANCEL = 'tour.click_move_to_workspace_cancel',
  TOUR_CLICK_SHARE_APPROVE = 'tour.click_share_approve',
  TOUR_CLICK_SHARE_CANCEL = 'tour.click_share_cancel',
  TOUR_CLICK_ARCHIVE_APPROVE = 'tour.click_archive_approve',
  TOUR_CLICK_ARCHIVE_CANCEL = 'tour.click_archive_cancel',
  TOUR_CLICK_SIDEBAR_TAB = 'tour.click_sidebar_tab',
  TOUR_CLICK_OPEN_ACTIONS_MENU = 'tour.click_open_actions_menu',
  TOUR_REORDER_FRAMES = 'tour.reorder_frames',
  TOUR_CLICK_CREATE_FROM_DEMO = 'tour.click_create_from_demo',
  TOUR_CLICK_CREATE_FROM_WEB = 'tour.click_create_from_web',
  TOUR_CLICK_CHOOSE_BASE_DEMO = 'tour.click_choose_base_demo',
  TOUR_CLICK_CHOOSE_BASE_DEMO_CREATE_NEW = 'tour.click_choose_base_demo_create_new',
  TOUR_CLICK_DOWNLOAD_ACTIVITY_TABLE = 'tour.click_download_activity_table',
  TOUR_DOWNLOAD_ACTIVITY_TABLE = 'tour.download_activity_table',
  TOUR_SELECT_TIME_FILTER = 'tour.select_time_filter',
  TOUR_CLICK_DIMENSIONS_SETUP_APPLY = 'tour.click_dimensions_setup_apply',
  TOUR_SELECT_DIMENSIONS_SETUP_DEVICE = 'tour.select_dimensions_setup_device',
  TOUR_ADD_SPEAKER_NOTES = 'tour.add_speaker_notes',
}
export enum TrackEventPresentationNames {
  PRESENTATION_CREATE_SHARE_LINK = 'presentation.create_share_link',
  PRESENTATION_UPDATE_SHARE_LINK = 'presentation.update_share_link',
  PRESENTATION_CLICK_TOGGLE_SHARE = 'presentation.click_toggle_share',
  PRESENTATION_CLICK_OPEN_CREATE_SHARE_LINK_MODAL = 'presentation.click_open_create_share_link_modal',
  PRESENTATION_TOGGLE_SHARE = 'presentation.toggle_share',
  PRESENTATION_CLICK_SPEAKER_MOUSE_ANIMATION_ACTIVATE = 'presentation.click_mouseanimation_activate',
  PRESENTATION_CLICK_SPEAKER_MOUSE_ANIMATION_DEACTIVATE = 'presentation.click_mouseanimation_deactivate',
  PRESENTATION_CLICK_SPEAKER_STACKING_ACTIVATE = 'presentation.click_speakerstacking_activate',
  PRESENTATION_CLICK_SPEAKER_STACKING_DEACTIVATE = 'presentation.click_speakerstacking_deactivate',
  PRESENTATION_CLICK_SPEAKER_NOTES_ACTIVATE = 'presentation.click_speakernotes_activate',
  PRESENTATION_CLICK_SPEAKER_NOTES_DEACTIVATE = 'presentation.click_speakernotes_deactivate',
}

export enum TrackEventCloneNames {
  CLONE_CLICK_OPEN_CLONER = 'clone.click_open_cloner',
  CLONE_CLICK_PREVIEW = 'clone.click_preview',
  CLONE_CLICK_OPEN_CREATE_DEMO_MODAL = 'clone.click_open_create_demo_modal',
  CLONE_CLICK_CREATE_DEMO = 'clone.click_create_demo',
  CLONE_CLICK_CANCEL = 'clone.click_cancel',
  CLONE_CLICK_EXIT = 'clone.click_exit',
  CLONE_CLICK_DUPLICATE = 'clone.click_duplicate',
  CLONE_CLICK_INFO = 'clone.click_info',
  CLONE_CLICK_SAVE_CLONING = 'clone.click_save_cloning',
  CLONE_CLICK_START_CLONING = 'clone.click_start_cloning',
  CLONE_CLICK_STOP_CLONING = 'clone.click_stop_cloning',
  CLONE_CLICK_OPEN_IN_EDITOR = 'clone.click_open_in_editor',
  CLONE_CLICK_CREATE_NEW = 'clone.click_create_new_clone',
  CLONE_CLICK_LEARN_MORE = 'clone.click_learn_more',
  CLONE_CLICK_GOT_IT = 'clone.click_got_it',
  CLONE_CLICK_OPEN_INFO = 'clone.click_open_info',
  CLONE_CLICK_CONTINUE_CLONING = 'clone.click_continue_cloning',
  CLONE_CLICK_FINISH_CLONING = 'clone.click_finish_cloning',
  CLONE_CLICK_DISCARD = 'clone.click_discard',
  CLONE_CLICK_ARCHIVE_CANCEL = 'clone.click_archive_cancel',
  CLONE_CLICK_ARCHIVE_APPROVE = 'clone.click_archive_approve',
  CLONE_CLICK_ARCHIVE = 'clone.click_archive',
}
export enum TrackEventNames {
  DEMO_SHARING_APPROVAL = 'demo.sharing_approval',
  DEMO_CLICK_OPEN_CLONER = 'demo.click_open_cloner',
  DEMO_CLICK_DUPLICATE = 'demo.click_duplicate',
  DEMO_CLICK_PREVIEW = 'demo.click_preview',
  DEMO_CLICK_EXIT_PREVIEW = 'demo.click_exit_preview',
  DEMO_CLICK_CREATE = 'demo.click_create',
  DEMO_CLICK_EDIT = 'demo.click_edit',
  DEMO_CLICK_CANCEL_EDIT = 'demo.click_cancel_edit',
  DEMO_CLICK_OPEN_PRESENTATION_DEMO_MODAL = 'demo.click_open_present_demo_modal',
  DEMO_CLICK_CANCEL_PRESENTATION_DEMO_MODAL = 'demo.click_cancel_present_demo_modal',
  DEMO_CLICK_OPEN_INFO = 'demo.click_open_info',
  DEMO_CLICK_EXIT = 'demo.click_exit',
  DEMO_CLICK_SAVE = 'demo.click_save',
  DEMO_CLICK_CREATE_AND_START_PRESENTATION = 'demo.click_create_and_start_presentation',
  DEMO_TOGGLE_PERMISSION_SHARE_PRESENTATION = 'demo.toggle_permission_share_presentation',
  DEMO_CLICK_START_PRESENTATION = 'demo.click_start_presentation',
  DEMO_CLICK_PLAY_LATER_PRESENTATION = 'demo.click_play_later_presentation',
  DEMO_CLICK_EXIT_PRESENTATION = 'demo.click_exit_presentation',
  DEMO_CLICK_OPEN_CREATE_DEMO_MODAL = 'demo.click_open_create_demo_modal',
  DEMO_CLICK_SAVE_EDIT = 'demo.click_save_edit',
  DEMO_CLICK_SAVE_EDIT_AND_EXIT = 'demo.click_save_edit_and_exit',
  DEMO_CLICK_OPEN_ACTIONS_MENU = 'demo.click_open_actions_menu',
  DEMO_CLICK_PRESENT = 'demo.click_present',
  DEMO_CLICK_SIDEBAR_TAB = 'demo.click_sidebar_tab',
  DEMO_CLICK_COPY_TO_WORKSPACE = 'demo.click_copy_to_workspace',
  DEMO_CLICK_SHARE = 'demo.click_share',
  DEMO_CLICK_SHARING_APPROVAL = 'demo.click_sharing_approval',
  DEMO_CLICK_ARCHIVE = 'demo.click_archive',
  DEMO_CLICK_MORE_ACTIONS = 'demo.click_more_actions',
  DEMO_CLICK_SHARE_PRESENTATION = 'demo.click_share_presentation',
  DEMO_CLICK_ARCHIVE_PRESENTATION = 'demo.click_archive_presentation',
  DEMO_CLICK_SEARCH = 'demo.click_search',
  DEMO_CLICK_FILTER = 'demo.click_filter',
  DEMO_CLICK_RESTORE_PRESENTATION = 'demo.click_restore_presentation',
  DEMO_CLICK_PREVIEW_PRESENTATION = 'demo.click_preview_presentation',
  DEMO_CLICK_ACTIONS = 'demo.click_actions',
  DEMO_CLICK_SET_START_PAGE = 'demo.click_set_start_page',
  DEMO_CLICK_COPY_SHARE_LINK = 'demo.click_copy_share_link',
  DEMO_CLICK_SHARE_SETTINGS = 'demo.click_share_settings',
  DEMO_CLICK_ACTIVATE_SHARE = 'demo.click_activate_share',
  DEMO_CLICK_DEACTIVATE_SHARE = 'demo.click_deactivate_share',
  DEMO_CLICK_REVERT = 'demo.click_revert',
  DEMO_CLICK_DUPLICATE_APPROVE = 'demo.click_duplicate_approve',
  DEMO_CLICK_DUPLICATE_CANCEL = 'demo.click_duplicate_cancel',
  DEMO_CLICK_COPY_TO_WORKSPACE_APPROVE = 'demo.click_copy_to_workspace_approve',
  DEMO_CLICK_COPY_TO_FOLDER_CANCEL = 'demo.click_copy_to_folder_cancel',
  DEMO_CLICK_COPY_TO_FOLDER_APPROVE = 'demo.click_copy_to_folder_approve',
  DEMO_CLICK_COPY_TO_WORKSPACE_CANCEL = 'demo.click_copy_to_workspace_cancel',
  DEMO_CLICK_SHARE_DEMO_APPROVE = 'demo.click_share_demo_approve',
  DEMO_CLICK_SHARE_DEMO_CANCEL = 'demo.click_share_demo_cancel',
  DEMO_CLICK_SHARE_PRESENTATION_APPROVE = 'demo.click_share_presentation_approve',
  DEMO_CLICK_SHARE_PRESENTATION_CANCEL = 'demo.click_share_presentation_cancel',
  DEMO_CLICK_REVERT_APPROVE = 'demo.click_revert_approve',
  DEMO_CLICK_REVERT_CANCEL = 'demo.click_revert_cancel',
  DEMO_CLICK_ARCHIVE_APPROVE = 'demo.click_archive_approve',
  DEMO_CLICK_ARCHIVE_CANCEL = 'demo.click_archive_cancel',
  DEMO_CLICK_ARCHIVE_PRESENTATION_APPROVE = 'demo.click_archive_presentation_approve',
  DEMO_CLICK_ARCHIVE_PRESENTATION_CANCEL = 'demo.click_archive_presentation_cancel',
  DEMO_CLICK_CREATE_TOUR = 'demo.click_create_tour',
  DEMO_CLICK_DOWNLOAD_ACTIVITY_TABLE = 'demo.click_download_activity_table',
  DEMO_DOWNLOAD_ACTIVITY_TABLE = 'demo.download_activity_table',
  DEMO_CLICK_SHARE_INTERNALLY = 'demo.click_share_internally',
  DEMO_ADD_SPEAKER_NOTES = 'demo.add_speaker_notes',
  DEMO_TOGGLE_GUIDANCE_TOOLTIPS = 'demo.toggle_guidance_tooltips',
  DEMO_MULTI_USER_LOCK = 'demo.multi_user_lock',
  CLICK_DOWNLOAD_DESKTOP_APP = 'click_download_desktop_app',
  CLICK_GO_TO_BROWSER_HOMEPAGE = 'click_go_to_browser_homepage',
  CLICK_CREATE_ACCOUNT = 'click_create_account',
  CLICK_OPEN_CLONER = 'click_open_cloner',
  CLICK_OPEN_CREATE_DEMO_MODAL = 'click_open_create_demo_modal',

  ORGANIZATION_TOGGLE_SHARE_POLICY = 'organization.toggle_share_policy',
  ORGANIZATION_TOGGLE_TOUR_SHARE_POLICY = 'organization.toggle_tour_share_policy',
  DESKTOPAPP_FIRST_LAUNCH = 'desktopapp.first_launch',
  DESKTOPAPP_LOGIN = 'desktopapp.login',

  AUTO_CLONE = 'auto.cloner',

  PRESENTATION_SELECT_TIME_FILTER = 'presentation.select_time_filter',
  DEMO_SELECT_TIME_FILTER = 'demo.select_time_filter',

  OVERLAY_CLICK_OPEN_CREATE = 'overlay.click_open_create_overlay',
  PRESENTER_LINK_CLICK_PRESENT = 'presenter_link.click_present',
}

export const AnalyticsTrackEventName = {
  ...TrackEventPresentationNames,
  ...TrackEventTourNames,
  ...WorkspaceRelatedTrackEventNames,
  ...TrackEventCloneNames,
  ...TrackEventNames,
  ...DashboardEventNames,
  ...TrackEventMimesis,
  ...FolderEventNames,
  ...PlaybookEventNames,
  ...NetworkEventNames,
};
